// import { useEffect } from "react";
import styled from "styled-components";

export const ListSearch = ({
  dataSearched = [],
  setDataSearched,
  onListSearch = "",
  setOnListSearch,
  setDataSelected = null,
  setValueSelected,
  lengthList = 4,
  maxHeight,
  messageNotFound = null,
  nameKey = "nombre",
  messageData = "",
}) => {
  const handleClick = (data) => {
    Object.keys(data).length > 0 && setValueSelected(data.nombre);
    if (setDataSelected) setDataSelected(data);
    setOnListSearch("");
    setDataSearched([]);
  };

  const TextComponent = ({ data }) => {
    switch (nameKey) {
      case "nombre":
        return <DataTextKey>{data.nombre}</DataTextKey>;
      case "siniestroId":
        return (
          <DataTextKey>
            #{String(data.siniestro_id).padStart(4, "0")}
          </DataTextKey>
        );
      default:
        return;
    }
  };

  return (
    <>
      {dataSearched.length > 0 && onListSearch !== "" && (
        <SearchList
          maxHeight={maxHeight}
          scroll={dataSearched.length >= lengthList && true}
        >
          {dataSearched.map((data, index) => (
            <DataContainer onClick={() => handleClick(data)} key={index}>
              <TextComponent data={data} />
            </DataContainer>
          ))}
        </SearchList>
      )}
      {onListSearch !== "" && (messageData === "Data Not Found" || (messageData === "" && dataSearched?.length === 0)) && messageNotFound && (
        <MessageNotFound>
          <MessageContainerText>
            <MessageText>{messageNotFound}</MessageText>
          </MessageContainerText>
        </MessageNotFound>
      )}
    </>
  );
};

const SearchList = styled.div`
  background-color: white;
  position: absolute;
  top: 50px;
  z-index: 2;
  width: 100%;
  border-radius: 7pt;
  box-shadow: 0 1px 1px rgb(0 0 0 / 0%), 0 2px 2px rgb(0 0 0 / 0%),
    0 4px 4px rgb(0 0 0 / 16%), 0 8px 8px rgb(0 0 0 / 14%);
  overflow-y: ${(props) => (props.scroll ? "scroll" : "hidden")};
  scroll-behavior: smooth;
  max-height: ${(props) => props.maxHeight || "150px"};
`;

const DataContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 7px;
  padding-right: 7px;
  padding-left: 7px;
  cursor: pointer;
  border-radius: 7px;

  &:hover {
    background-color: #dcdcdc;
  }
`;

const DataTextKey = styled.p`
  padding: 0px 8px 0px 8px;
`;

const MessageText = styled.p`
  color: #fa4b4b;
  font-size: 15px;
`;

const MessageContainerText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const MessageNotFound = styled.div`
  background-color: white;
  position: absolute;
  top: 50px;
  z-index: 2;
  width: 100%;
  height: 70px;
  border-radius: 7px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 0%), 0 2px 2px rgb(0 0 0 / 0%),
    0 4px 4px rgb(0 0 0 / 16%), 0 8px 8px rgb(0 0 0 / 14%);
`;
